export default "__VITE_ASSET__DP2KCrNZ__"